var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review"},[_vm._v(" Metrics Report ")])
}
var staticRenderFns = []

export { render, staticRenderFns }